import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import CoordinateLineChart from '../core/CoordinateLineChart';
import { Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "charts-passing-coorditantes-as-data"
    }}>{`Charts passing coorditantes as data`}</h1>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <h1 {...{
      "id": "line-chart-with-negative-values"
    }}>{`Line chart with negative values`}</h1>
    <Playground __position={0} __code={'<CoordinateLineChart\n  title=\"Respiratory volume chart\"\n  toolboxTooltip={{ saveAsImageWithTitle: \'save as image\' }}\n  height={400}\n  xMaxValue={8}\n  legendNames={[\'ref\', \'pre\', \'pos\']}\n  coordinateNames={{\n    x: \'Volume (L)\',\n    y: \'Fluxo (L/s)\',\n  }}\n  colors={[\'gray\', \'orange\', \'green\']}\n  coordinates={[\n    [\n      { x: 0.1, y: 0.5 },\n      { x: 0.4, y: 0.9 },\n      { x: 2, y: 0.9 },\n      { x: 3, y: 1 },\n      { x: 4, y: 5.9 },\n      { x: 5, y: 6 },\n      { x: 6, y: 6 },\n      { x: 8, y: 6 },\n    ],\n    [\n      { x: 0.1, y: 7.5 },\n      { x: 0.4, y: 7.3 },\n      { x: 2, y: 7 },\n      { x: 3, y: 6.5 },\n      { x: 4, y: 2 },\n      { x: 5, y: 4 },\n      { x: 6, y: 4.3 },\n      { x: 8, y: 7.5 },\n    ],\n    [\n      { x: 0.1, y: 1 },\n      { x: 0.4, y: 7.4 },\n      { x: 2, y: 7.2 },\n      { x: 3, y: 7.9 },\n      { x: 4, y: 2.1 },\n      { x: 5, y: 4.3 },\n      { x: 6, y: 4.5 },\n      { x: 8, y: 7.6 },\n    ],\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      CoordinateLineChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <CoordinateLineChart title='Respiratory volume chart' toolboxTooltip={{
        saveAsImageWithTitle: 'save as image'
      }} height={400} xMaxValue={8} legendNames={['ref', 'pre', 'pos']} coordinateNames={{
        x: 'Volume (L)',
        y: 'Fluxo (L/s)'
      }} colors={['gray', 'orange', 'green']} coordinates={[[{
        x: 0.1,
        y: 0.5
      }, {
        x: 0.4,
        y: 0.9
      }, {
        x: 2,
        y: 0.9
      }, {
        x: 3,
        y: 1
      }, {
        x: 4,
        y: 5.9
      }, {
        x: 5,
        y: 6
      }, {
        x: 6,
        y: 6
      }, {
        x: 8,
        y: 6
      }], [{
        x: 0.1,
        y: 7.5
      }, {
        x: 0.4,
        y: 7.3
      }, {
        x: 2,
        y: 7
      }, {
        x: 3,
        y: 6.5
      }, {
        x: 4,
        y: 2
      }, {
        x: 5,
        y: 4
      }, {
        x: 6,
        y: 4.3
      }, {
        x: 8,
        y: 7.5
      }], [{
        x: 0.1,
        y: 1
      }, {
        x: 0.4,
        y: 7.4
      }, {
        x: 2,
        y: 7.2
      }, {
        x: 3,
        y: 7.9
      }, {
        x: 4,
        y: 2.1
      }, {
        x: 5,
        y: 4.3
      }, {
        x: 6,
        y: 4.5
      }, {
        x: 8,
        y: 7.6
      }]]} mdxType="CoordinateLineChart" />
    </Playground>
    <h1 {...{
      "id": "line-chart-with-negative-values-on-y-axis"
    }}>{`Line chart with negative values on y axis`}</h1>
    <Playground __position={1} __code={'<div style={{ width: \'300px\', height: \'400px\' }}>\n  <CoordinateLineChart\n    title=\"Respiratory flow chart\"\n    height={400}\n    legendNames={[\'ref\', \'pre\', \'pos\']}\n    yRangeValues={8}\n    legendPosition={30}\n    grid={{ top: 80 }}\n    xMaxValue={8}\n    coordinateNames={{\n      x: \'Volume (L)\',\n      y: \'Fluxo (L/s)\',\n    }}\n    colors={[\'gray\', \'orange\', \'green\']}\n    coordinates={[\n      [\n        { x: 0.5, y: 7.5 },\n        { x: 0.7, y: 7.3 },\n        { x: 1.2, y: 7 },\n        { x: 1.3, y: 6.5 },\n        { x: 2, y: -2 },\n        { x: 4, y: -4 },\n        { x: 5, y: 4.3 },\n        { x: 0.5, y: 7.5 },\n      ],\n      [\n        { x: 0.6, y: 7.5 },\n        { x: 0.9, y: 7.3 },\n        { x: 1.4, y: 7 },\n        { x: 1.5, y: 6.5 },\n        { x: 2.2, y: -2 },\n        { x: 4.2, y: -4 },\n        { x: 5.2, y: 4.3 },\n        { x: 0.6, y: 7.5 },\n      ],\n      [\n        { x: 0.3, y: 7.5 },\n        { x: 0.6, y: 7.3 },\n        { x: 1, y: 7 },\n        { x: 1.2, y: 6.5 },\n        { x: 1.8, y: -2 },\n        { x: 3.8, y: -4 },\n        { x: 4.8, y: 4.3 },\n        { x: 0.3, y: 7.5 },\n      ],\n    ]}\n  />\n</div>'} __scope={{
      props,
      DefaultLayout,
      CoordinateLineChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <div style={{
        width: '300px',
        height: '400px'
      }}>
        <CoordinateLineChart title='Respiratory flow chart' height={400} legendNames={['ref', 'pre', 'pos']} yRangeValues={8} legendPosition={30} grid={{
          top: 80
        }} xMaxValue={8} coordinateNames={{
          x: 'Volume (L)',
          y: 'Fluxo (L/s)'
        }} colors={['gray', 'orange', 'green']} coordinates={[[{
          x: 0.5,
          y: 7.5
        }, {
          x: 0.7,
          y: 7.3
        }, {
          x: 1.2,
          y: 7
        }, {
          x: 1.3,
          y: 6.5
        }, {
          x: 2,
          y: -2
        }, {
          x: 4,
          y: -4
        }, {
          x: 5,
          y: 4.3
        }, {
          x: 0.5,
          y: 7.5
        }], [{
          x: 0.6,
          y: 7.5
        }, {
          x: 0.9,
          y: 7.3
        }, {
          x: 1.4,
          y: 7
        }, {
          x: 1.5,
          y: 6.5
        }, {
          x: 2.2,
          y: -2
        }, {
          x: 4.2,
          y: -4
        }, {
          x: 5.2,
          y: 4.3
        }, {
          x: 0.6,
          y: 7.5
        }], [{
          x: 0.3,
          y: 7.5
        }, {
          x: 0.6,
          y: 7.3
        }, {
          x: 1,
          y: 7
        }, {
          x: 1.2,
          y: 6.5
        }, {
          x: 1.8,
          y: -2
        }, {
          x: 3.8,
          y: -4
        }, {
          x: 4.8,
          y: 4.3
        }, {
          x: 0.3,
          y: 7.5
        }]]} mdxType="CoordinateLineChart" />
    </div>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      